import React, {Component} from 'react';
import {connect} from 'react-redux';
import Registration from '../../components/Registration/Registration';
import { ToastContainer, toast } from 'react-toastify';
import {  Redirect, withRouter } from 'react-router-dom';
import { createUser } from '../../store/actions/registrationAction';
import { stat } from 'fs';
import { verifyOnExist, resetVerifyState } from '../../store/actions/verifyActions';

class RegistrationContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            
        };
    }

    componentWillUnmount() {
      this.props.resetVerifyState();
    }

    render() {
      return(
        <Registration
            createUser={this.props.createUser}
            createdUserFetching={this.props.createdUserFetching}
            verifyOnExist={this.props.verifyOnExist}
            verifyState={this.props.verifyState}
            createdUserData={this.props.createdUserData}
            createdUserError={this.props.createdUserError}
        />
      )
    }
}

function MapStateToProps(state, ownProps) {
  return {
    createdUserFetching: state.registration.createdUserFetching,
    createdUserData: state.registration.createdUserData,
    createdUserError: state.registration.createdUserError,
    verifyState: state.verify,
  };
}

const mapDispatchToProps = (dispatch) => ({
    createUser: (data) => dispatch(createUser(data)),
    verifyOnExist : (data) => dispatch(verifyOnExist(data)),
    resetVerifyState: () => dispatch(resetVerifyState()),
});


export default withRouter(connect(MapStateToProps, mapDispatchToProps)(RegistrationContainer));



// WEBPACK FOOTER //
// ./src/containers/Registration/RegistrationContainer.jsx